export default __webpack_public_path__ + "static/media/vnpt_banner.c2bb1e5c.jpg";